<div class="acc-content">

  <div class="font18 xsmbt5 mbt20 " translate>lblHowWeCanHelpYouToday?</div>
  <div class="row mt-2 align-items-end">
      <div class="col-12">
          <div class="cst-input-field big">
              <label class="mrt20" translate>lblMileage
                  <span translate class="font10 text-red d-inline-block"
                  [ngbTooltip]="">
                  lblPreviousMileageMessage
              </span>
                </label>
          </div>
      </div>
  </div>
  <div class="row align-items-end">
    <div class="col-auto">
      <div class="cst-input-field big">

        <div class="pos-relative" style="float: left;">
          <input type="number" value="" class="text-right kminput wid150" [(ngModel)]="mileage" (keyup)="checkMileage()" min="0" maxlength="8" 
          />
           <em class="country-code km">KM</em>
        </div>
      </div>
      <div translate class="flex-grow cst-validation stepThreeValidation mrt20 fix" *ngIf="isMileageError">
        lblPleaseEnterAppropriateMileage
      </div>
    </div>
    <div class="col-auto mt-2 mt-md-0 pl-2">
      <button translate class="btn btn-primary btn-lg" *ngIf="!isShowService" (click)="ShowServices()">
        lblShowServices
      </button>
    </div>
  </div>
  
  

  <div class="mtp20" style="clear:both" *ngIf='isShowService'>

    <div class="cst-input-field">
      <label translate>lblPleaseSelectTheServiceYouLikeToAvail</label>
    </div>

      <div *ngIf="selectedServices && selectedServices.length > 0" class="showon-service-selection transition mtp10 mbt10 xsmtp10 showon-service">
        <label class="label-big dis-blk xsmbt0" translate> lblSelectedServices </label>
        <ul class="listing-st-1 listing-st-2 flexwrap xsmtp5">
          <li *ngFor="let item of selectedServices;let i = index" (click)="removeService(i,item)" class="transition">
            {{ item.name }}
          </li>
        </ul>
      </div>

  </div>
  <div class="selectTabBlock transition" *ngIf='isShowService'>
    <ul class="TabLeft">
      <li *ngFor="let item of serviceCategories;let i = index" (click)="changeCategory(i)"
        [ngClass]="{selected: i === selectedServiceIndex}" class="">
        <a href="javascript:void(0)" class="">
          <span class="service-name">{{item.service}}</span>
          <span class="count"></span>
          <strong class="count">0</strong>
        </a>
      </li>
    </ul>

    <div class="sublisting">
      <ul class="selectTab">
        <ng-container *ngIf="serviceList.length>0; else load_else;">
          <li *ngFor="let service of serviceList" [ngClass]="{selected: checkIfServiceSelected(service)}">

            <div class="w-100">
              <div class="d-flex align-items-center">
                <label class="cstcheckbox flmid fullspace bold font16 mb-0">
                    <input type="checkbox" id="Service{{service.id}}" (click)="selectService(service,$event)"
                    [checked]="checkIfServiceSelected(service)"
                        class="form-check-input"  />
                    <span></span>
                    {{service.name}} 
                </label> 
                <div class="ml-2" [ngClass]="checkIfServiceSelected(service)?'':'disable'" *ngIf="allowCustomerToUploadDoc">
                    <i class="fa fa-upload" aria-hidden="true" (click)="OpenModel(uploadContent,service)" ngbTooltip="{{'lblUploadDocument' | translate}}" tooltipClass="custom-revert"></i>
                  </div>
                <div class="ml-auto">
                  <em class="fa fa-info-circle " *ngIf="!service.isDisplayPrice" placement="left" ngbTooltip="Price via Dealer"></em>
                  <span *ngIf="service.isDisplayPrice" class="text-green bold nowrap">{{service.priceIncVat |number:'1.2-2'}}</span>
                </div>
              </div>
              <div class="discription" >
                <p [innerHTML]="service.description"></p>
                <div class="mtp10 cst-input-field" *ngIf="service.isAdditionalCustomerComment && !service.addedAsChildService">
                  <label for="" class="font14">{{service.additionalCustomerCommentTextBoxLabel}}</label>
                  <textarea name="" id="" rows="2" (change)="onChangeCommentService(service)"
                  maxlength="500" [(ngModel)]="service.additionalCustomerComment" class="form-control"></textarea>
                </div>

              </div>
              <div class="warningLights discription border rounded-3 p-3 mt-2" *ngIf="isWarningLightFeature && service.isWarningLight">
                <label translate>lblWarningLight<span>:</span></label>
                <div>
                  <span class="imgWid d-inline-block position-relative mr-3 bodyIcon" *ngFor="let warninglight of service.warningLightIdList" 
                  [ngClass]="{'selectedWarningLight':warninglight.isSelected }">
                    <img af-image [data-src]="warninglight.Image" [attr.alt]="warninglight.WarningNameName" 
                    [ngClass]="{'disable' : !checkIfServiceSelected(service)}"
                    (click)="onSelectWarningLight(warninglight,service)" width="70px">
                    <em class="fas fa-check-circle"></em>
                  </span>
                </div>
                
              </div>
              
            </div>
             <div class="w-100" *ngIf="checkIfServiceSelected(service)"> 
            <div class="w-100 mtp10 sub-cat"  *ngFor="let childservice of service.displaychildServiceDetail; let i = index">
              <div class="d-flex align-items-center">
                <label class="cstcheckbox flmid fullspace w100 bold font16 mb-0">
                  <input type="checkbox" 
                  [disabled]="false"
                      class="form-check-input disable" (click)="SelectChildService(childservice)"  [checked]="checkIfServiceSelected(childservice)" id="service{{i}}"/>
                  <span></span>
                  {{childservice.name}}
              </label> 
              <div class="ml-auto">
                <em class="fa fa-info-circle" *ngIf="!childservice.isDisplayPrice" placement="left" ngbTooltip="Price via Dealer"></em>
                <span *ngIf="childservice.isDisplayPrice" class="text-green bold nowrap">{{childservice.priceIncVat |number:'1.2-2'}}</span>
              </div>
              </div>
            
              <div class="discription">
                <p >{{childservice.description}}</p>

                <div class="mtp10 cst-input-field" *ngIf="childservice.isAdditionalCustomerComment">
                  <label for="" class="font14">{{childservice.additionalCustomerCommentTextBoxLabel}}</label>
                  <textarea name="" id="" rows="2" maxlength="500" [(ngModel)]="childservice.additionalCustomerComment" class="form-control"></textarea>
                </div>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-template #load_else>
          <div style="font-weight: 700;" translate>lblNoServiceAvailable</div>
        </ng-template>
      </ul>

      <div class="mtp20" id="serviceSection" *ngIf="displayServiceSection">
        <div class="boxst3 mtp10 mbt20">
          <h4 class="title-h4 mbt20" translate>
            lblDoYouSeeAnyCodeInYourCarDashboard?
          </h4>
          <p class="font18 mbt15" translate>
            lblIf ThereIsAnyCodeThatIsDisplayed
          </p>
          <div class="">
            <div class="mbt15 xsmbt5 flex-center flexwrap">
              <label class="cst-radio flexbox mrt10 font18">
                <input type="radio" checked [value]="true" name="code" [(ngModel)]="isCode" />
                <span class="mrt10"></span>
                <p translate>lblYes,IHaveACode</p>
              </label>
              <input type="text" class="inputst2 width90 mrt15" [(ngModel)]="code" [disabled]="!isCode" />
              <a href="javascript:void(0)" class="xsflexcenter flex-grow xsmbt10 showleftpopover cst-note pos-rel">
                <span class="mrt10 xsmrt5" translate>lblWhatDoesTheCodeMean?</span>
              </a>

              <div class="leftpopover xsmbt15">
                <em class="close-btn"></em>
                <h6 class="title-h6 mbt5">
                  <strong translate>lblMBCODEINFORMATION</strong>
                </h6>
                <p><strong translate>lblWhatDoTheServiceCodesMean?</strong></p>
                <p class="mbt15" translate>
                  lblTheLetterTellsHowComprehensiveTheServiceIs.
                </p>
                <p>
                  <strong translate>lblASmallService,BLargerService,etc.</strong>
                </p>
                <p translate>
                  lblTheFigureTellsUsWhatNeedsToBeDone
                </p>
              </div>
            </div>
            <div>
              <label class="cst-radio flexbox font18">
                <input type="radio" [value]="false" name="code" [(ngModel)]="isCode" />
                <span class="mrt10"></span>
                <p translate>lblDon'tknow/SeeNothingInTheDisplay</p>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="mtp20" id="bodyRepairSection" *ngIf="displayBodyRepairSection">
        <div>
          <h5 class="title-h5 mbt5">
            <strong translate>lblClickOnTheIllustrationToNoteWhereTheDamageIs</strong>
          </h5>
          <div class="clearfix bodyrepaircont greyborder">
            <div id="bodyrepair">
              <img src="assets/images/bodyrepair-temp.png" id="bodyDamageImage"
                class="mbt30 xsmbt10 cursorpointer img-responsive" (click)="onBodyRepairClick($event)" alt="" />
              <span *ngFor="let item of damageIcons;let i = index"
                [ngStyle]="{left: item.left + 'px', top: item.top + 'px'}" (click)="removeIcon(i)"><em
                  class="close-btn-white removeSelectedBody iconImage"></em></span>
            </div>
          </div>
          <h5 class="title-h5 mbt5">
            <strong translate>lblDescribeTheDamage</strong>
          </h5>
          <textarea class="width666 height100 csttextarea xs100force" [(ngModel)]="damageDescription"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf='isShowService' class="text-info p-2 d-flex align-items-center">
    <em class="fas fa-info-circle fa-lg align-middle"
        style="vertical-align: middle;"></em>
    <span translate class="ml-2 mr-2" style="font-size: small;font-style: italic;">lblVaryServicePrice</span>
</div>

  <div class="clearfix mtp30 xsmtp20" *ngIf="isShowService">
    <div class="flex-center space-between fright">
      <div translate class="flex-grow cst-validation stepTwoValidation mrt20 txtright"
        *ngIf="isDirty && selectedServices.length === 0">
        lblPleaseSelectOneOrMoreServices.
      </div>
      <div class="btn-grp fright xsmbt10 flex-center xsmtp15 xsflexend">
        <button translate class="btn btn-secondary fleft mrt20 ng-binding" aria-label="Center Align" (click)=" goToPrevious()">
          <em class="pos-relative fa fa-angle-left mr-2"></em> lblBack
        </button>
        <button translate class="btn btn-primary"
          [ngClass]="{'disable': selectedServices.length === 0 || isMileageError}" aria-label="Center Align" (click)="completeStep()" value="Next"
          id="showStep3">
          lblNext <em class="pos-relative fa fa-angle-right ml-2"></em>
        </button>
      </div>
    </div>
  </div>
</div>